module.exports = __webpack_public_path__ + "images/banners/review/banner_review_280_24e136c0115addfb4ede46e84a9e4977.gif";